module.exports = __webpack_public_path__ + "tc.98d2c0644c467f6abc3e.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/tc.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/tc.svg
// module chunks = styles